import { ChipStateType } from '@kubit/web-ui-components/chip/types';
import { closeIconCommonStyles, commonStyles, labelCommonStyles, leftIconCommonStyles, rangeIconCommonStyles, rangeItemSeparatorCommonStyles, rangeItemTextCommonStyles, rangeItemWrapperCommonStyles, } from '../commonStyles';
import { ChipVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [ChipVariantType.DEFAULT]: {
            [ChipStateType.DEFAULT]: {
                chipContainer: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    border_color: FOUNDATIONS.color_comp_forms_chip_border,
                    background_color: FOUNDATIONS.color_comp_forms_chip_bg,
                },
                leftIcon: {
                    ...leftIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_icon_50,
                },
                label: {
                    ...labelCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                rangeItemWrapper: {
                    ...rangeItemWrapperCommonStyles(FOUNDATIONS, FONT),
                },
                rangeItemText: {
                    ...rangeItemTextCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                rangeItemSeparator: {
                    ...rangeItemSeparatorCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_font_50,
                },
                rangeIcon: {
                    ...rangeIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_icon_50,
                },
                closeIcon: {
                    ...closeIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_neutral_icon_50,
                },
            },
            [ChipStateType.DISABLED]: {
                chipContainer: {
                    ...commonStyles(FOUNDATIONS, FONT),
                    border_color: FOUNDATIONS.color_accent_disabled_border_50,
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                leftIcon: {
                    ...leftIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                label: {
                    ...labelCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                rangeItemWrapper: {
                    ...rangeItemWrapperCommonStyles(FOUNDATIONS, FONT),
                },
                rangeItemText: {
                    ...rangeItemTextCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                rangeItemSeparator: {
                    ...rangeItemSeparatorCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                },
                rangeIcon: {
                    ...rangeIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                closeIcon: {
                    ...closeIconCommonStyles(FOUNDATIONS, FONT),
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
        },
    };
};
//# sourceMappingURL=default.js.map